const React = require('react');
const Button = require('components/button');
const Row = require('components/row');
const Col = require('components/col');
const FormInput = require('components/form-input');
const api = require('utils/api-controller');
const toastService = require('utils/toast-service');
const modal = require('utils/modal-service');
const ctrl = require('controllers/sys-ctrl');

module.exports = React.createClass({

	mixins:	[ctrl.mixin],

	getInitialState(){
		return {
			userName: '',
			password: ''
		};
	},

	submitForm(ev){
		ev.preventDefault();
		api.login(this.state.userName,this.state.password);
	},

	linkState(propName){
		var self = this;
		return {
			value: this.state[propName],
			requestChange(newValue){
				var data = {};
				data[propName] = newValue;
				self.setState(data);
			}
		};
	},

  handleForgetPass(ev){
    ev.preventDefault();

    if (!this.state.userName || this.state.userName.indexOf('@') == -1) {
      toastService.toast('Informe um e-mail válido','danger');
      return;
    }

    var email = this.state.userName;

    modal.show(function(){
      api.forgotPass(email);
    }, 'Esqueci minha senha', 'Confirma o envio de e-mail com link para definição de nova senha para '+this.state.userName+' ?');

  },

	render(){
		return (
			<div className="site-body">
				<div className="container">
					<div className="login-header">
            <Row>
              <Col size="sm-12" className="text-center">
                <img className="logo" src="logotipo" alt=""/>
              </Col>
            </Row>
						<Row>
							<Col size="sm-12" className="text-center">
								<h1>Bem vindo ao {ctrl.data.pageHeader}</h1>
							</Col>
						</Row>
						<p>Efetue o login para ter acesso aos produtos que estão com cotação em aberto.</p>
					</div>
					<div className="row">
						<div className="col-sm-6 col-sm-offset-3 login-box">
							<form onSubmit={this.submitForm}>
                <Row><FormInput autofocus={true} size='sm-12' className="form-control input-lg" valueLink={this.linkState('userName')} placeholder='usuario@email.com.br' label="Usuário"/></Row>
                <Row><FormInput size='sm-12' className="form-control input-lg" valueLink={this.linkState('password')} type="password" label="Senha"  /></Row>
								<div className="row">
									<div className="col-sm-12">
										<a href="" className="pull-right" onClick={this.handleForgetPass}>Esqueci minha senha</a>
									</div>
								</div>
								<hr/>
								<div className="row">
									<div className="col-sm-12">
										<button className="btn btn-lg btn-primary form-control input-lg" type="submit">Efetuar login</button>
									</div>
								</div>
							</form>
						</div>
					</div>
					<div className="row" style={{marginTop: 40}}>
						<div className="col col-sm-12 text-center" dangerouslySetInnerHTML={{__html: ctrl.data.msgTiraDuvidas}}></div>
					</div>
				</div>
			</div>
		);
	}

});


/** WEBPACK FOOTER **
 ** ./src/views/login/login-form.js
 **/